import React from 'react';
import styled from 'styled-components/macro';

import HandwriteEllipse, { Wrapper as _HandwriteEllipse } from '../common/components/svg/HandwriteEllipse';
import useFlavorStore from '../common/store/useFlavorStore';

const Wrapper = styled.div`
  position: relative;
  margin: 30rem 0;
  width: fit-content;

  ${_HandwriteEllipse} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-48%, -50%);
    height: 40rem;
  }
`;

const Text = styled.h5`
  text-transform: uppercase;
  font-size: 13rem;
  line-height: normal;
`;

const Heading = () => {
  const flavor = useFlavorStore(state => state.flavor);

  return (
    <Wrapper>
      <HandwriteEllipse color={`var(--${flavor})`} />
      <Text>Next Info</Text>
    </Wrapper>
  );
}

export default Heading;